"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayHelper = void 0;
var ArrayHelper = /** @class */ (function () {
    function ArrayHelper() {
    }
    ArrayHelper.getMax = function (values) {
        var max;
        values.forEach(function (value) {
            if (max === undefined || value > max) {
                max = value;
            }
        });
        return max;
    };
    ArrayHelper.getMin = function (values) {
        var min;
        values.forEach(function (value) {
            if (min === undefined || value < min) {
                min = value;
            }
        });
        return min;
    };
    ArrayHelper.groupBy = function (array, keyGetter) {
        var map = new Map();
        array.forEach(function (item) {
            var key = keyGetter(item);
            /* If cannot get key for item do nothing */
            if (!key) {
                return;
            }
            var collection = map.get(key);
            if (!collection) {
                map.set(key, [item]);
            }
            else {
                collection.push(item);
            }
        });
        return Array.from(map);
    };
    return ArrayHelper;
}());
exports.ArrayHelper = ArrayHelper;
//# sourceMappingURL=ArrayHelper.js.map